import {
  Button,
  DialogActions,
  DialogContent,
  Stack,
  Typography,
} from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import CheckCircle from "@mui/icons-material/CheckCircle";

interface Props {
  doClose: () => void;
}

export const Success = ({ doClose }: Props) => {
  const { t } = useTenantTranslation();

  return (
    <>
      <DialogContent>
        <Stack
          height="100%"
          direction="column"
          alignItems="center"
          justifyContent="center"
          gap="12px"
        >
          <CheckCircle sx={{ color: "success.main", height: 28, width: 28 }} />
          <Typography variant="h5">
            {t("thePlanHasBeenSuccessfullyDeployed")}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={doClose}>
          {t("done")}
        </Button>
      </DialogActions>
    </>
  );
};
